/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST_BONUS(state, data) {
    state.list = data;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_BONUS_SETTING_TEACHER(state, data) {
    state.bonus_teacher = data;
  },
  UPDATE_BONUS_SETTING_TEACHER(state, data) {
    const pos = state.bonus_teacher
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);

    state.bonus_teacher.splice(pos, 1, data);
  },
};
